"use client";

import { c as _c } from "react/compiler-runtime";
import { SocialLink, type SocialPlatform } from "@repo/design-system/components/social-link";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { getCurrentYear } from "@repo/design-system/utils/date-helpers";
import { useLanguage } from "~/translations/loader/use-language";

/** Footer for E.ON Grid Solutions (legacy Footer.eon.eongrid). */
export default function FooterEonGridsolutions() {
  const $ = _c(21);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      platform: "linkedin",
      href: "https://www.linkedin.com/company/eon-grid-solutions/",
      title: "E.ON Grid Solutions auf LinkedIn"
    }, {
      platform: "kununu",
      href: "https://www.kununu.com/de/eon-grid-solutions",
      title: "E.ON Grid Solutions auf kununu"
    }, {
      platform: "xing",
      href: "https://www.xing.com/pages/eon-grid-solutions",
      title: "E.ON Grid Solutions auf Xing"
    }, {
      platform: "instagram",
      href: "https://www.instagram.com/eon_grid_career/",
      title: "E.ON Grid Solutions auf Instagram"
    }, {
      platform: "youtube",
      href: "https://www.youtube.com/channel/UC6K0VGJi3XyqdjYEOuqzakQ",
      title: "E.ON Grid Solutions auf YouTube"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const socials = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ul aria-label="Social media" className="mb-7 flex h-8 items-center lg:mb-auto lg:h-auto">{socials.map(_temp)}</ul>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.footer_imprint) {
    t2 = <li><CustomLink blank={true} className="hover:underline md:mx-3" data-source="text" href="https://www.eon-gridsolutions.com/de/impressum.html">{t.footer_imprint}</CustomLink></li>;
    $[2] = t.footer_imprint;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t.footer_link_privacyPolicy || $[5] !== t.footer_privacyPolicy) {
    t3 = <li><CustomLink blank={true} href={t.footer_link_privacyPolicy}>{t.footer_privacyPolicy}</CustomLink></li>;
    $[4] = t.footer_link_privacyPolicy;
    $[5] = t.footer_privacyPolicy;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t.footer_privacySettings) {
    t4 = <li><button className="cursor-pointer hover:underline md:mx-3" data-source="lc" onClick={_temp2} type="button">{t.footer_privacySettings}</button></li>;
    $[7] = t.footer_privacySettings;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li><CustomLink blank={true} className="hover:underline md:mx-3" data-source="text" href="https://www.eon.com/de/ueber-uns/entsprechenserklaerung/hinweisgebersystem.html">Hinweisgebersystem (Whistleblowing)</CustomLink></li>;
    t6 = <li><CustomLink blank={true} className="hover:underline md:mx-3" data-source="text" href="https://www.eon.com/de/ueber-uns/corporate-governance/verhaltenskodex.html">E.ON Verhaltenskodex</CustomLink></li>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t7 = <div className="flex flex-col md:flex-row md:justify-between lg:gap-x-4">{t1}<ul className="mb-9 grid flex-wrap justify-start font-semibold text-sm leading-6 md:flex md:w-1/2 md:justify-end lg:m-auto lg:justify-start">{t2}{t3}{t4}{t5}{t6}</ul></div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="order-2 lg:order-1" data-source="text">{`© E.ON SE ${getCurrentYear()}`}</p>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `${t.client} Logo`;
  let t10;
  if ($[16] !== t9) {
    t10 = <div className="flex w-full flex-col justify-start gap-x-8 gap-y-4 text-[#8f9192] text-sm md:flex-row md:justify-between lg:w-auto lg:items-center lg:justify-end xl:gap-x-20">{t8}<CustomLink blank={true} className="order-1 lg:order-2" href="https://www.eon-gridsolutions.com/de.html"><CustomImage alt={t9} className="lg:h-8 lg:w-24" data-source="lc" height={30} src="images/logo/logo_footer.svg" width={100} /></CustomLink></div>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <footer className="outer-container justify-center bg-white py-6 print:hidden"><div className="inner-container flex flex-col justify-between lg:flex-row">{t7}{t10}</div></footer>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp2() {
  return window.UC_UI?.showSecondLayer();
}
function _temp(s) {
  return <li className="mx-2.5 first:mr-2.5 first:ml-0" key={s.href}><SocialLink aria-label={s.title} className="flex shadow-none" classNameIcon="text-foreground" href={s.href} social={s.platform} title={s.title} /></li>;
}